import React from 'react';
import {View, Text} from 'react-native';
import CustomPressable from '../../components/customPressable/customPressable';
import {useCssStyle} from '../../customHook/getCssStyle';

const RoomControlSection = ({
  title,
  groups = [],
  groupLabelKey,
  itemsKey,
  codeKey: codeKeyProp,
  labelKey: labelKeyProp,
  styleKey = "",
  type,
  controlInterface = {},
  onAction,
}) => {
  const getStyles = useCssStyle();

  if (!groups?.length) return null;

  const resolveKeys = control => {
    if (codeKeyProp && labelKeyProp)
      return {codeKey: codeKeyProp, labelKey: labelKeyProp};

    const keys = Object.keys(control || {});
    return {
      codeKey: codeKeyProp || keys.find(k => k.toLowerCase().endsWith('code')),
      labelKey:
        labelKeyProp || keys.find(k => k.toLowerCase().endsWith('label')),
    };
  };

  const resolveGroupKeys = group => {
    const keys = Object.keys(group || {});
    return {
      resolvedGroupLabelKey:
        groupLabelKey || keys.find(k => k.toLowerCase().includes('label')),
      resolvedItemsKey: itemsKey || keys.find(k => Array.isArray(group[k])),
    };
  };

  return (
    <View
      style={getStyles(['roomControlItemContainer', `roomControlItemContainer_${styleKey}`])}
      id={`roomControlItemContainer roomControlItemContainer_${styleKey}`}>
      {title && <Text
        style={getStyles(['roomControlItemTitle', `roomControlItemTitle_${styleKey}`])}
        id={`roomControlItemTitle roomControlItemTitle_${styleKey}`}>
        {title}
      </Text>}

      <View
        style={getStyles(['roomControlSwitchContainer', `roomControlSwitchContainer_${styleKey}`])}
        id={`roomControlSwitchContainer roomControlSwitchContainer_${styleKey}`}>
        {groups.map((group, groupIndex) => {
          const {resolvedGroupLabelKey, resolvedItemsKey} =
            resolveGroupKeys(group);
          const controls = resolvedItemsKey ? group[resolvedItemsKey] : [];

          if (!controls?.length) return null;

          const {codeKey, labelKey} = resolveKeys(controls[0]);
          if (!codeKey || !labelKey) return null;

          return (
            <View
              key={group[resolvedGroupLabelKey] || groupIndex}
              style={getStyles(['roomControlSwitchContainerItems', `roomControlSwitchContainerItems_${styleKey}`])}
              id={`roomControlSwitchContainerItems roomControlSwitchContainerItems_${styleKey}`}>
              {group[resolvedGroupLabelKey] ? (
                <Text
                  style={getStyles(['roomControlSubItemTitle', `roomControlSubItemTitle_${styleKey}`])}
                  id={`roomControlSubItemTitle roomControlSubItemTitle_${styleKey}`}>
                  {group[resolvedGroupLabelKey]}
                </Text>
              ) : null}

              <View
                style={getStyles(['roomControlItemSubContainer', `roomControlItemSubContainer_${styleKey}`])}
                id={`roomControlItemSubContainer roomControlItemSubContainer_${styleKey}`}>
                {controls.map(control => (
                  <CustomPressable
                    key={control[codeKey]}
                    onPress={() =>
                      onAction(control[codeKey], controlInterface, type)
                    }
                    style={getStyles(['roomControlButtonContainer', `roomControlButtonContainer_${styleKey}`])}
                    id={`roomControlButtonContainer roomControlButtonContainer_${styleKey}`}>
                    <Text
                      style={getStyles(['roomControlButtonText', `roomControlButtonText_${styleKey}`])}
                      id={`roomControlButtonText roomControlButtonText_${styleKey}`}>
                      {control[labelKey]}
                    </Text>
                  </CustomPressable>
                ))}
              </View>
            </View>
          );
        })}
      </View>
    </View>
  );
};

export default RoomControlSection;